import { isEmpty } from "lodash";
import React from "react";

const RenderOddsVelkie = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  active,
  betType,
}) => {
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0 || !isEmpty(odds)) {
        if (Number(odds) > limit?.oddsLimit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  return (
    <div className="w-4/12 relative grid gap-0.5 grid-cols-2">
      {odds_back?.length > 0 ? (
        odds_back?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldBack?.length > 0
              ? res?.rt != oldBack[id]?.rt || res?.bv != oldBack[id]?.bv
              : false;
          return (
            <div
              onClick={(e) => {
                if (disabelBack) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(res, "back", item?.RunnerName, item, e);
                  }
                }
              }}
              style={
                check(res?.rt)
                  ? { cursor: "not-allowed", position: "relative" }
                  : { position: "relative" }
              }
              data-v-2acc6d71
              className={`py-1.5 h-36px text-center rounded-md bg-back-300 ${
                active && betType == "back" ? "back-active" : ""
              } ${
                chamak ? "animate-spark-back" : ""
              }`}
              title="BACK"
              betinfoid="40497467-BACK"
            >
              {check(res?.rt) && ms == 1 && (
                <div class="absolute right-0 top-0 flex justify-center items-center w-full h-full bg-black-700 opacity-80 text-11 text-white rounded-md" />
              )}
              <h3 data-v-2acc6d71 className="text-15 pb-0.5">
                {res?.rt || ""}
              </h3>
              {component !== "bookmaker" && (
                <p data-v-2acc6d71 className="text-9">
                  {res?.bv || ""}
                </p>
              )}
            </div>
          );
        })
      ) : (
        <div
          data-v-2acc6d71
          className="py-1.5 h-36px text-center rounded-md bg-back-300"
          title="BACK"
          betinfoid="40497467-BACK"
        >
          <h3 data-v-2acc6d71 className="text-15 pb-0.5"></h3>
          <p data-v-2acc6d71 className="text-9"></p>
        </div>
      )}
      {odds_lay?.length > 0 ? (
        odds_lay?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldLay?.length > 0
              ? res?.rt != oldLay[id]?.rt || res?.bv != oldLay[id]?.bv
              : false;
          return (
            <div
              onClick={(e) => {
                if (disabelLay) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(res, "lay", item?.RunnerName, item, e);
                  }
                }
              }}
              style={
                check(res?.rt)
                  ? { cursor: "not-allowed", position: "relative" }
                  : { position: "relative" }
              }
              data-v-2acc6d71
              className={`py-1.5 h-36px text-center rounded-md bg-lay-300 ${
                active && betType == "lay" ? "lay-active" : ""
              } ${
                chamak ? "animate-spark-lay" : ""
              }`}
              title="LAY"
              betinfoid="40497467-LAY"
            >
              {check(res?.rt) && ms == 1 && (
                <div class="absolute right-0 top-0 flex justify-center items-center w-full h-full bg-black-700 opacity-80 text-11 text-white rounded-md" />
              )}
              <h3 data-v-2acc6d71 className="text-15 pb-0.5">
                {res?.rt || ""}
              </h3>{" "}
              {component !== "bookmaker" && (
                <p data-v-2acc6d71 className="text-9">
                  {res?.bv || ""}
                </p>
              )}
            </div>
          );
        })
      ) : (
        <div
          data-v-2acc6d71
          className="py-1.5 h-36px text-center rounded-md bg-lay-300"
          title="LAY"
          betinfoid="40497467-LAY"
        >
          <h3 data-v-2acc6d71 className="text-15 pb-0.5"></h3>
          <p data-v-2acc6d71 className="text-9"></p>
        </div>
      )}
      {disableFull && ms == 1 && (
        <div class="absolute right-0 top-0 flex justify-center items-center w-full h-full bg-black-700 opacity-80 text-11 text-white rounded-md">
          Suspended
        </div>
      )}
    </div>
  );
};

export default RenderOddsVelkie;
